// extracted by mini-css-extract-plugin
export var bannerTitle = "banner-module--banner-title--90eee";
export var banner_section_container = "banner-module--banner_section_container--e2853";